import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\UpdatePlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/UpdatePlaceController.php
* @route '/api/place/{place}'
*/
const UpdatePlaceController = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePlaceController.url(args, options),
    method: 'put',
})

UpdatePlaceController.definition = {
    methods: ["put"],
    url: '/api/place/{place}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\WikiPlace\UpdatePlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/UpdatePlaceController.php
* @route '/api/place/{place}'
*/
UpdatePlaceController.url = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { place: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { place: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            place: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        place: typeof args.place === 'object'
        ? args.place.id
        : args.place,
    }

    return UpdatePlaceController.definition.url
            .replace('{place}', parsedArgs.place.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\UpdatePlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/UpdatePlaceController.php
* @route '/api/place/{place}'
*/
UpdatePlaceController.put = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePlaceController.url(args, options),
    method: 'put',
})

export default UpdatePlaceController